import { Tag } from 'antd';
import React from 'react';

interface TagDisplayProps {
	tag: {
		id: string;
		name: string;
		color: string;
		createdAt: Date;
		updatedAt: Date;
	};
}

// Funkce pro převod hex barvy na RGB
const hexToRgb = (hex: string): { r: number; g: number; b: number } | null => {
	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	if (!result) {
		return null;
	}
	return {
		r: parseInt(result[1], 16),
		g: parseInt(result[2], 16),
		b: parseInt(result[3], 16),
	};
};

// Funkce pro výpočet jasu barvy (0-255)
const getLuminance = (r: number, g: number, b: number): number => {
	const [rs, gs, bs] = [r, g, b].map(c => {
		// eslint-disable-next-line no-param-reassign
		c /= 255;
		// eslint-disable-next-line no-restricted-properties
		return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
	});
	return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs;
};

// Funkce pro ztmavení barvy
const darkenColor = (hex: string, amount: number = 0.3): string => {
	const rgb = hexToRgb(hex);
	if (!rgb) {
		return '#000000';
	}

	const { r, g, b } = rgb;
	const newR = Math.max(0, Math.floor(r * (1 - amount)));
	const newG = Math.max(0, Math.floor(g * (1 - amount)));
	const newB = Math.max(0, Math.floor(b * (1 - amount)));

	return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`;
};

// Hlavní funkce pro výběr barvy textu
const getTextColor = (backgroundColor: string): string => {
	const rgb = hexToRgb(backgroundColor);
	if (!rgb) {
		return '#ffffff';
	}

	const { r, g, b } = rgb;
	const luminance = getLuminance(r, g, b);

	// Pokud je barva tmavá (luminance < 0.5), použij bílou
	if (luminance < 0.5) {
		return '#ffffff';
	}

	// Pokud je barva světlá, použij tmavší verzi aktuální barvy
	return darkenColor(backgroundColor, 0.6);
};

const TagDisplay: React.FC<TagDisplayProps> = ({ tag }) => (
	<Tag bordered={false} style={{ color: getTextColor(tag.color) }} color={tag.color}>
		{tag.name}
	</Tag>
);

export default TagDisplay;
